import React from "react";

import ColorPicker from "./color-picker";
import ModalButton from "../../attributes/compare-table/modal-button";

const ColorPickerModal = ({ name, defaultValue, updateOnChange }) => {
    return (
        <ModalButton text="Color Picker">
            <ColorPicker name={name} defaultValue={defaultValue} updateOnChange={updateOnChange} />
        </ModalButton>
    );
};

export default ColorPickerModal;
